var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.349976 23C0.349976 22.5029 0.752919 22.1 1.24998 22.1H22.75C23.247 22.1 23.65 22.5029 23.65 23C23.65 23.497 23.247 23.9 22.75 23.9H1.24998C0.752919 23.9 0.349976 23.497 0.349976 23Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55676 4.13956C5.55676 3.80819 5.82539 3.53956 6.15676 3.53956H6.78467C7.11604 3.53956 7.38467 3.80819 7.38467 4.13956C7.38467 4.47093 7.11604 4.73956 6.78467 4.73956H6.15676C5.82539 4.73956 5.55676 4.47093 5.55676 4.13956Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32422 4.13956C9.32422 3.80819 9.59285 3.53956 9.92422 3.53956H10.5521C10.8835 3.53956 11.1521 3.80819 11.1521 4.13956C11.1521 4.47093 10.8835 4.73956 10.5521 4.73956H9.92422C9.59285 4.73956 9.32422 4.47093 9.32422 4.13956Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55676 6.65116C5.55676 6.31979 5.82539 6.05116 6.15676 6.05116H6.78467C7.11604 6.05116 7.38467 6.31979 7.38467 6.65116C7.38467 6.98253 7.11604 7.25116 6.78467 7.25116H6.15676C5.82539 7.25116 5.55676 6.98253 5.55676 6.65116Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32422 6.65116C9.32422 6.31979 9.59285 6.05116 9.92422 6.05116H10.5521C10.8835 6.05116 11.1521 6.31979 11.1521 6.65116C11.1521 6.98253 10.8835 7.25116 10.5521 7.25116H9.92422C9.59285 7.25116 9.32422 6.98253 9.32422 6.65116Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55676 9.16282C5.55676 8.83145 5.82539 8.56282 6.15676 8.56282H6.78467C7.11604 8.56282 7.38467 8.83145 7.38467 9.16282C7.38467 9.49419 7.11604 9.76282 6.78467 9.76282H6.15676C5.82539 9.76282 5.55676 9.49419 5.55676 9.16282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32422 9.16282C9.32422 8.83145 9.59285 8.56282 9.92422 8.56282H10.5521C10.8835 8.56282 11.1521 8.83145 11.1521 9.16282C11.1521 9.49419 10.8835 9.76282 10.5521 9.76282H9.92422C9.59285 9.76282 9.32422 9.49419 9.32422 9.16282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55676 11.6744C5.55676 11.343 5.82539 11.0744 6.15676 11.0744H6.78467C7.11604 11.0744 7.38467 11.343 7.38467 11.6744C7.38467 12.0058 7.11604 12.2744 6.78467 12.2744H6.15676C5.82539 12.2744 5.55676 12.0058 5.55676 11.6744Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32422 11.6744C9.32422 11.343 9.59285 11.0744 9.92422 11.0744H10.5521C10.8835 11.0744 11.1521 11.343 11.1521 11.6744C11.1521 12.0058 10.8835 12.2744 10.5521 12.2744H9.92422C9.59285 12.2744 9.32422 12.0058 9.32422 11.6744Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55676 14.1861C5.55676 13.8547 5.82539 13.5861 6.15676 13.5861H6.78467C7.11604 13.5861 7.38467 13.8547 7.38467 14.1861C7.38467 14.5174 7.11604 14.7861 6.78467 14.7861H6.15676C5.82539 14.7861 5.55676 14.5174 5.55676 14.1861Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32422 14.1861C9.32422 13.8547 9.59285 13.5861 9.92422 13.5861H10.5521C10.8835 13.5861 11.1521 13.8547 11.1521 14.1861C11.1521 14.5174 10.8835 14.7861 10.5521 14.7861H9.92422C9.59285 14.7861 9.32422 14.5174 9.32422 14.1861Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55676 16.6977C5.55676 16.3663 5.82539 16.0977 6.15676 16.0977H6.78467C7.11604 16.0977 7.38467 16.3663 7.38467 16.6977C7.38467 17.029 7.11604 17.2977 6.78467 17.2977H6.15676C5.82539 17.2977 5.55676 17.029 5.55676 16.6977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32422 16.6977C9.32422 16.3663 9.59285 16.0977 9.92422 16.0977H10.5521C10.8835 16.0977 11.1521 16.3663 11.1521 16.6977C11.1521 17.029 10.8835 17.2977 10.5521 17.2977H9.92422C9.59285 17.2977 9.32422 17.029 9.32422 16.6977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.11719 3.99998C2.11719 1.84606 3.86328 0.0999756 6.01719 0.0999756H10.6916C12.8455 0.0999756 14.5916 1.84606 14.5916 3.99998V23C14.5916 23.497 14.1887 23.9 13.6916 23.9H3.01719C2.52013 23.9 2.11719 23.497 2.11719 23V3.99998ZM6.01719 1.89998C4.85739 1.89998 3.91719 2.84018 3.91719 3.99998V22.1H12.7916V3.99998C12.7916 2.84018 11.8514 1.89998 10.6916 1.89998H6.01719Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7916 6.65116C12.7916 6.1541 13.1946 5.75116 13.6916 5.75116H17.8544C20.0083 5.75116 21.7544 7.49725 21.7544 9.65116V22.9767C21.7544 23.4738 21.3515 23.8767 20.8544 23.8767H13.6916C13.1946 23.8767 12.7916 23.4738 12.7916 22.9767V6.65116ZM14.5916 7.55116V22.0767H19.9544V9.65116C19.9544 8.49136 19.0142 7.55116 17.8544 7.55116H14.5916Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2779 9.79099C16.2779 9.45962 16.5465 9.19099 16.8779 9.19099H17.5058C17.8372 9.19099 18.1058 9.45962 18.1058 9.79099C18.1058 10.1224 17.8372 10.391 17.5058 10.391H16.8779C16.5465 10.391 16.2779 10.1224 16.2779 9.79099Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2779 12.3027C16.2779 11.9713 16.5465 11.7027 16.8779 11.7027H17.5058C17.8372 11.7027 18.1058 11.9713 18.1058 12.3027C18.1058 12.6341 17.8372 12.9027 17.5058 12.9027H16.8779C16.5465 12.9027 16.2779 12.6341 16.2779 12.3027Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2779 14.8144C16.2779 14.4831 16.5465 14.2144 16.8779 14.2144H17.5058C17.8372 14.2144 18.1058 14.4831 18.1058 14.8144C18.1058 15.1458 17.8372 15.4144 17.5058 15.4144H16.8779C16.5465 15.4144 16.2779 15.1458 16.2779 14.8144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2779 17.3252C16.2779 16.9938 16.5465 16.7252 16.8779 16.7252H17.5058C17.8372 16.7252 18.1058 16.9938 18.1058 17.3252C18.1058 17.6565 17.8372 17.9252 17.5058 17.9252H16.8779C16.5465 17.9252 16.2779 17.6565 16.2779 17.3252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.81256 20.7791C6.81256 19.9275 7.50288 19.2372 8.35442 19.2372C9.20597 19.2372 9.89628 19.9275 9.89628 20.7791V22.9767C9.89628 23.3081 9.62765 23.5767 9.29628 23.5767H7.41256C7.08119 23.5767 6.81256 23.3081 6.81256 22.9767V20.7791ZM8.35442 20.4372C8.16562 20.4372 8.01256 20.5903 8.01256 20.7791V22.3767H8.69628V20.7791C8.69628 20.5903 8.54323 20.4372 8.35442 20.4372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.65 20.7787C15.65 19.9272 16.3403 19.2369 17.1918 19.2369C18.0434 19.2369 18.7337 19.9272 18.7337 20.7787V22.9764C18.7337 23.3078 18.4651 23.5764 18.1337 23.5764H16.25C15.9186 23.5764 15.65 23.3078 15.65 22.9764V20.7787ZM17.1918 20.4369C17.003 20.4369 16.85 20.5899 16.85 20.7787V22.3764H17.5337V20.7787C17.5337 20.5899 17.3806 20.4369 17.1918 20.4369Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/Building.6021945d7271c0418cf4fd2d266896a3.svg";
export { ForwardRef as ReactComponent };